import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { EXPIRATION_PROMOTIONS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createOrUpdateProductExpirationPromotionsAction = createAsyncThunk(
    'price/createOrUpdateProductExpirationPromotionsAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(`${ EXPIRATION_PROMOTIONS_PATH }/product/${ data.productId }`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createOrUpdateProductExpirationPromotionsSlice = createSlice({
    name: 'createOrUpdateProductExpirationPromotionsSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createOrUpdateProductExpirationPromotionsAction.pending, () => STATE__API__STARTED);
        builder.addCase(createOrUpdateProductExpirationPromotionsAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createOrUpdateProductExpirationPromotionsAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createOrUpdateProductExpirationPromotionsState = (state) => state.price.createOrUpdateProductExpirationPromotions;
export default createOrUpdateProductExpirationPromotionsSlice.reducer;
